import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-deprecated */
import React, { Component, cloneElement, Children } from 'react';
import { safeInvoke } from '../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Measure from 'react-measure';
import { CLS_PREFIX } from '../../constants';
import Pagination from '../Pagination';
import Grid from '../Grid';
import GridCol from '../GridCol';
import Button from '../Button';
import Spinner from '../Spinner';
import Translate from '../Translate';
import CardListToolbar from './CardListToolbar';
export var VIEW_TILE = 'tile';
export var VIEW_RESPONSIVE = 'responsive';
export var VIEW_EXTENDED = 'extended';
export var VIEW_ROW = 'row';
/**
 * @deprecated `CardList` was used for displaying list of objects presented in various data formats
 * including images and other interface components.
 * Now it is deprecated and [List should be used](#!/List) instead.
 * @since 0.0.54
 */

var CardList =
/*#__PURE__*/
function (_Component) {
  _inherits(CardList, _Component);

  function CardList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      page: _this.props.defaultPage,
      totalItems: _this.props.totalItems || _this.props.items.length,
      pageSize: 10,
      items: _this.props.items,
      view: _this.props.view
    });

    _defineProperty(_assertThisInitialized(_this), "selectAll", function () {
      var items = _this.state.items;

      _this.select(items.map(_this.getItemKey));
    });

    _defineProperty(_assertThisInitialized(_this), "selectNone", function () {
      _this.select([]);
    });

    _defineProperty(_assertThisInitialized(_this), "getItemKey", function (item) {
      var itemKey = _this.props.itemKey;
      return item[itemKey];
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (item) {
      var _this$props = _this.props,
          baseClassName = _this$props.baseClassName,
          itemRender = _this$props.itemRender,
          onSelectionChange = _this$props.onSelectionChange;
      var view = _this.state.view;
      return cloneElement(itemRender(item), {
        key: _this.getItemKey(item),
        view: _this.isTile() ? VIEW_TILE : view,
        className: classNames("".concat(baseClassName, "__list-item")),
        selection: onSelectionChange ? _this.itemSelection(item) : null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "previousView", null);

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (_ref) {
      var width = _ref.bounds.width;
      var view = width > 584 ? _this.previousView : VIEW_RESPONSIVE;

      if (view === VIEW_RESPONSIVE && !_this.previousView) {
        _this.previousView = _this.state.view;
      } else if (view !== VIEW_RESPONSIVE) {
        _this.previousView = null;
      }

      if (view && view !== _this.state.view) {
        _this.changeView(view);
      }
    });

    return _this;
  }

  _createClass(CardList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchItems();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var view = this.props.view;

      if (view !== prevProps.view && this.state.view !== VIEW_RESPONSIVE) {
        this.fetchItems({
          page: 1,
          view: view
        });
      }
    }
  }, {
    key: "totalPages",
    value: function totalPages() {
      var _this$state = this.state,
          totalItems = _this$state.totalItems,
          pageSize = _this$state.pageSize;
      return Math.ceil(totalItems / pageSize);
    }
  }, {
    key: "fetchItems",
    value: function fetchItems() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$page = _ref2.page,
          page = _ref2$page === void 0 ? this.state.page : _ref2$page,
          _ref2$view = _ref2.view,
          view = _ref2$view === void 0 ? this.state.view : _ref2$view;

      var onItemsFetch = this.props.onItemsFetch;
      var pageSize = view === VIEW_ROW ? 40 : 10;
      this.setState({
        view: view,
        page: page,
        pageSize: pageSize
      });
      safeInvoke(onItemsFetch, {
        page: page,
        pageSize: pageSize
      });
    }
  }, {
    key: "loadMore",
    value: function loadMore() {
      var onItemsFetch = this.props.onItemsFetch;
      var page = this.state.page;
      var nextPage = page + 1;
      this.setState({
        page: nextPage,
        pageSize: 10
      });
      safeInvoke(onItemsFetch, {
        page: nextPage,
        pageSize: 10
      });
    }
  }, {
    key: "isTile",
    value: function isTile() {
      var view = this.state.view;
      return view === VIEW_TILE || view === VIEW_RESPONSIVE;
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var _this2 = this;

      var baseClassName = this.props.baseClassName;
      var _this$state2 = this.state,
          page = _this$state2.page,
          view = _this$state2.view;
      var totalPages = this.totalPages();

      if (totalPages < 2) {
        return null;
      }

      if (view === VIEW_RESPONSIVE && page < totalPages) {
        return React.createElement("div", {
          className: "".concat(baseClassName, "__pagination")
        }, React.createElement(Button, {
          onClick: function onClick() {
            return _this2.loadMore();
          }
        }, React.createElement(Translate, {
          content: 'CardList.loadMore',
          fallback: 'Load more'
        })));
      }

      return React.createElement(Pagination, {
        className: "".concat(baseClassName, "__pagination"),
        total: totalPages,
        current: page,
        onSelect: function onSelect(page) {
          return _this2.fetchItems({
            page: page
          });
        }
      });
    }
  }, {
    key: "changeView",
    value: function changeView(view) {
      var onViewChange = this.props.onViewChange;
      this.fetchItems({
        page: 1,
        view: view
      });
      safeInvoke(onViewChange, view);
    }
  }, {
    key: "select",
    value: function select(keys) {
      var onSelectionChange = this.props.onSelectionChange;
      onSelectionChange(keys);
    }
  }, {
    key: "itemSelection",
    value: function itemSelection(item) {
      var _this3 = this;

      var key = this.getItemKey(item);
      var selection = this.props.selection;
      return {
        isSelected: selection.indexOf(key) > -1,
        onSelectionChange: function onSelectionChange(_ref3) {
          var isSelected = _ref3.isSelected;
          var keys = isSelected ? [].concat(_toConsumableArray(selection), [key]) : selection.filter(function (k) {
            return k !== key;
          });

          _this3.select(keys);
        }
      };
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      var _this$props2 = this.props,
          baseClassName = _this$props2.baseClassName,
          loading = _this$props2.loading;

      if (!loading) {
        return null;
      }

      return React.createElement("div", {
        className: "".concat(baseClassName, "__content-blocker")
      }, React.createElement("div", {
        className: "".concat(baseClassName, "__loader")
      }, React.createElement(Spinner, {
        className: "".concat(baseClassName, "__loader-spinner")
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props3 = this.props,
          baseClassName = _this$props3.baseClassName,
          className = _this$props3.className,
          items = _this$props3.items,
          onItemsFetch = _this$props3.onItemsFetch,
          view = _this$props3.view,
          itemKey = _this$props3.itemKey,
          itemRender = _this$props3.itemRender,
          onViewChange = _this$props3.onViewChange,
          selection = _this$props3.selection,
          onSelectionChange = _this$props3.onSelectionChange,
          selectionButton = _this$props3.selectionButton,
          viewSwitcher = _this$props3.viewSwitcher,
          toolbarGroups = _this$props3.toolbarGroups,
          totalItems = _this$props3.totalItems,
          defaultPage = _this$props3.defaultPage,
          loading = _this$props3.loading,
          props = _objectWithoutProperties(_this$props3, ["baseClassName", "className", "items", "onItemsFetch", "view", "itemKey", "itemRender", "onViewChange", "selection", "onSelectionChange", "selectionButton", "viewSwitcher", "toolbarGroups", "totalItems", "defaultPage", "loading"]);

      var content = this.state.items.map(this.renderItem);

      if (this.isTile()) {
        content = React.createElement(Grid, {
          minColumnWidth: 400,
          gap: "md"
        }, Children.map(content, function (child) {
          return React.createElement(GridCol, {
            key: child.props.key
          }, child);
        }));
      }

      return React.createElement(Measure, {
        bounds: true,
        onResize: this.handleResize
      }, function (_ref4) {
        var measureRef = _ref4.measureRef;
        return React.createElement("div", _extends({
          ref: measureRef,
          className: classNames(baseClassName, className)
        }, props), React.createElement(CardListToolbar, {
          selection: onSelectionChange && _this4.state.totalItems > 1 ? _objectSpread({}, selectionButton, {
            total: _this4.state.totalItems,
            onSelectAll: _this4.selectAll,
            onSelectNone: _this4.selectNone,
            checked: _this4.state.items.length === selection.length
          }) : null,
          onViewChange: viewSwitcher ? function (view) {
            return _this4.changeView(view);
          } : null,
          currentView: _this4.state.view,
          groups: toolbarGroups
        }), _this4.state.items.length > 0 && React.createElement("div", {
          className: "".concat(baseClassName, "__list ").concat(baseClassName, "__list--").concat(_this4.state.view)
        }, content), _this4.state.items.length === 0 && !loading && React.createElement(Translate, {
          content: "CardList.notFound",
          fallback: "No items found."
        }), _this4.renderPagination(), _this4.renderLoader());
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var items = props.items,
          totalItems = props.totalItems;
      var prevItems = state.prevItems,
          prevTotalItems = state.prevTotalItems;
      var nextState = {};

      if (items !== prevItems) {
        nextState.items = items;
      }

      if (totalItems !== prevTotalItems) {
        nextState.totalItems = totalItems || items.length;
      }

      nextState.prevItems = items;
      nextState.prevTotalItems = totalItems || items.length;
      return nextState;
    }
  }]);

  return CardList;
}(Component);

CardList.propTypes = {
  /**
   * Array of data items for rendering.
   * @since 0.0.68
   */
  items: PropTypes.array.isRequired,

  /**
   * Callback for fetching items.
   * @since 0.0.68
   */
  onItemsFetch: PropTypes.func,

  /**
   * Total items. Equal items.length by default.
   * @since 0.0.68
   */
  totalItems: PropTypes.number,

  /**
   * Default page number.
   * @since 1.0.1
   */
  defaultPage: PropTypes.number,

  /**
   * View mode.
   * @since 0.0.54
   */
  view: PropTypes.oneOf([VIEW_EXTENDED, VIEW_TILE, VIEW_ROW, VIEW_RESPONSIVE]),

  /**
   * View change callback.
   * @since 0.0.54
   */
  onViewChange: PropTypes.func,

  /**
   * View switcher config.
   * @since 0.0.59
   */
  viewSwitcher: PropTypes.bool,

  /**
   * Array of keys of selected cards.
   * @since 0.0.59
   */
  selection: PropTypes.array,

  /**
   * Selection change handler for list. Checkboxes will only be rendered if this prop is defined.
   * @since 0.0.59
   */
  onSelectionChange: PropTypes.func,

  /**
   * Config for selection button in the toolbar.
   * @since 0.0.59
   */
  selectionButton: PropTypes.shape({
    /**
     * See [Badge](#!/Badge) for all props.
     */
    badge: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

    /**
     * Array of additional [MenuItems](#!/MenuItem).
     */
    menuItems: PropTypes.arrayOf(PropTypes.element)
  }),

  /**
   * Toolbar groups for the toolbar.
   * @since 0.0.59
   */
  toolbarGroups: PropTypes.arrayOf(PropTypes.element),

  /**
   * Unique key.
   * @since 0.0.59
   */
  itemKey: PropTypes.string.isRequired,

  /**
   * Render function for item.
   * @since 0.0.59
   */
  itemRender: PropTypes.func.isRequired,

  /**
   * Indicate the loading state of the list.
   * @since 0.0.68
   */
  loading: PropTypes.bool,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
CardList.defaultProps = {
  onItemsFetch: null,
  totalItems: null,
  defaultPage: 1,
  view: VIEW_EXTENDED,
  onViewChange: null,
  viewSwitcher: false,
  selection: [],
  onSelectionChange: null,
  selectionButton: {
    badge: null,
    menuItems: []
  },
  toolbarGroups: [],
  loading: false,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "card-list")
};
export default CardList;